import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { AmazonRedshiftTableDataset } from 'app/model/dataset/amazon-redshift.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonRedshiftTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class AmazonRedshiftTableDatasetAdapter extends TabularTypeDatasetAdapter<AmazonRedshiftTableDataset, Model.DatasetResource> {
}
